export default function BrandsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Brands</title>
      <path
        d="M20.734 21.7024C21.2699 21.7024 21.7044 21.268 21.7044 20.7321C21.7044 20.1962 21.2699 19.7617 20.734 19.7617C20.1981 19.7617 19.7637 20.1962 19.7637 20.7321C19.7637 21.268 20.1981 21.7024 20.734 21.7024Z"
        fill="currentColor"
      />
      <path
        d="M20.733 4.23757C21.269 4.23757 21.7034 3.80313 21.7034 3.26722C21.7034 2.73132 21.269 2.29688 20.733 2.29688C20.1971 2.29688 19.7627 2.73132 19.7627 3.26722C19.7627 3.80313 20.1971 4.23757 20.733 4.23757Z"
        fill="currentColor"
      />
      <path
        d="M3.26722 4.23757C3.80313 4.23757 4.23757 3.80313 4.23757 3.26722C4.23757 2.73132 3.80313 2.29688 3.26722 2.29688C2.73132 2.29688 2.29688 2.73132 2.29688 3.26722C2.29688 3.80313 2.73132 4.23757 3.26722 4.23757Z"
        fill="currentColor"
      />
      <path
        d="M3.26722 21.7024C3.80313 21.7024 4.23757 21.268 4.23757 20.7321C4.23757 20.1962 3.80313 19.7617 3.26722 19.7617C2.73132 19.7617 2.29688 20.1962 2.29688 20.7321C2.29688 21.268 2.73132 21.7024 3.26722 21.7024Z"
        fill="currentColor"
      />
      <path
        d="M18.3751 7.49272L13.1999 4.25822C12.84 4.03331 12.4242 3.91406 11.9999 3.91406C11.5755 3.91406 11.1597 4.03331 10.7999 4.25822L5.6247 7.49272C5.29887 7.69636 5.03023 7.97957 4.84406 8.31569C4.65789 8.65181 4.56033 9.02978 4.56055 9.41401V14.5892C4.56033 14.9734 4.65789 15.3514 4.84406 15.6875C5.03023 16.0236 5.29887 16.3069 5.6247 16.5105L10.7999 19.745C11.1613 19.9656 11.5765 20.0823 11.9999 20.0823C12.4233 20.0823 12.8385 19.9656 13.1999 19.745L18.3751 16.5105C18.7009 16.3069 18.9696 16.0236 19.1557 15.6875C19.3419 15.3514 19.4395 14.9734 19.4392 14.5892V9.41401C19.4395 9.02978 19.3419 8.65181 19.1557 8.31569C18.9696 7.97957 18.7009 7.69636 18.3751 7.49272ZM6.50125 9.23611L11.0295 6.40592V11.4517L6.50125 14.1687V9.23611ZM11.9999 18.2054L7.85973 15.6178L11.9999 13.1337L16.14 15.6178L11.9999 18.2054ZM17.4985 14.1687L12.9702 11.4517V6.40592L17.4985 9.23611V14.1687Z"
        fill="currentColor"
      />
    </svg>
  );
}
